import React, {useEffect, useState} from "react";
import IconDesc from "../my-course/IconDesc";
import Button from "olive-react-myoneui/lib/Button";
import moment from 'moment';
import timezone from 'moment-timezone';
import { rssIcon, chatIcon, archiveIcon, geoMarkIcon } from "../../../constants/icons";
import EventTag from "./eventTag";
import AddToCartButton from "../AddToCartButton";
import BuyNowButton from "../BuyNowButton";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EnrollNowButton from "../EnrollNowButton";
import RedirectURLObject from "../../RedirectURLObject";
import IamInterestedButton from "../IamInterestedButton";

function CourseEvent({coursedetails, itemType, eventDetails, currentCurrency, memberPricingLabel, currentDateTime, currentPricingLabel, showMemberPrice, isCartEnabled, selectedTimeZone, className }) {
  const [eventPrice, setEventPrice]               = useState('');
  const [eventBuyStatus, setEventBuyStatus]       = useState('');
  const [eventBuyStatusTag, setEventBuyStatusTag] = useState('');
  const [seatLeft, setSeatLeft]                   = useState(null);
  const [eventTimeDiff, setEventTimeDiff]         = useState('');
  const [eventDateHtml, setEventDateHtml]         = useState('');
  const [eventStartDate, setEventStartDate]       = useState('');
  const [addToCartBtn, setAddToCartBtn]           = useState('');
  const [buyNowBtn, setBuyNowBtn]                 = useState('');
  const navigate                                  = useNavigate();
  const miscellaneous                             = useSelector((state) => state.user.miscellaneous);
  const waitingListURL = RedirectURLObject({ type: 'enroll_now', redirectTo: `/cart_react?item=${itemType}_${eventDetails?.id}` })

  // console.log('event_details', eventDetails);

  let addToCartButton                           = '';
  let buyNowButton                              = '';

  let seat_waiting = false;
  let seat_available =false;
  let seat_sold = false;
  let bceDeliveryType                   = eventDetails?.bce_delivered_type;
  let bce_slug                          = eventDetails?.bce_slug;  
  let event_price                       = eventDetails?.bce_price;
  let bce_enquiry_needed                = eventDetails?.bce_enquiry_needed;
  let displayPrice                      = eventDetails?.bce_price_label;
  let event_maximum_registration_limit  = eventDetails?.bce_maximum_registration_limit;
  let price_type                        = eventDetails?.bce_pricetype;
  let event_attendee_waiting_enabled    = eventDetails?.bce_attendee_waiting;
  let event_total_registrations         = eventDetails?.bce_total_registrations;
  let event_id                          = eventDetails?.id;
  let schedule_type                     = eventDetails?.bce_schedule_type;
  let schedule_description              = eventDetails?.bce_schedule_description;
  let registration_status               = eventDetails?.bce_registration_status;
  let venue_location                    = (eventDetails?.bce_venue_location === null) ? '' : eventDetails.bce_venue_location;
  let allow_register                    = eventDetails?.allow_register;
  let coming_soon                       = eventDetails?.coming_soon;
  let registration_closed               = eventDetails?.registration_closed;
  let registration_disabled             = eventDetails?.registration_disabled;
  let eventDateTime                     = eventDetails?.bce_start_date+' '+eventDetails?.bce_start_time;
  let showSeatAvailability              = eventDetails?.bce_show_seat_availability;
  let bceVenue                          = eventDetails?.bce_venue;

  let _member_status                    = eventDetails?.bce_member_status;
  let _member_price                     = eventDetails?.bce_member_price;

  let selected_timezone                 = selectedTimeZone?.name_without_offset;

  let date_html   = '';
  let show_prices = 0;

  const enquireFn = (coursedetails, itemType) => {
    navigate(`/enquiry?name=${encodeURIComponent(coursedetails?.course?.bce_name)}&type=${itemType == "booking_event" ? "event" : encodeURIComponent(itemType)}&id=${encodeURIComponent(coursedetails?.course?.bce_course_id)}`)
  }

  const viewMoreClickHandler = () => {
    navigate('/'+ bce_slug);
  }

  const GetMonthName = (monthNumber, full=false) =>{
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if(full){
      return monthsFull[monthNumber - 1];
    } else {
      return months[monthNumber - 1];
    }
  }

  const inCart = (id,item_type) => {
	
    var index       =   (item_type+'_'+id);
    var cart        =   localStorage.getItem("mycart") != null ? JSON.parse(localStorage.getItem("mycart")) : {};
  
    if(cart[index]){
      return true;
    }
    return false;
  }

  const renderEventActivities = () => {

    show_prices   = 0;
    let price_html    = 'free';//_free_event_label;
    if (price_type == 'paid') {
      // price_html =  __current_currency.symbol_code + event_price;
       show_prices    = 1;
       price_html = `<span class="rupee-unicode">${currentCurrency.symbol_code}</span>${event_price}`;
    }

      if (registration_status == 0) {
       allow_register = false;
       registration_closed = true;
      }
       seat_waiting = false;
       seat_available =false;
       seat_sold = false; 
       var seat_message = '';    
       var seat_left_message   = '';
       if(event_total_registrations == null || event_total_registrations == 'null'){
          event_total_registrations  = 0;
       }     
      if (registration_disabled == 0) {       
          if (parseInt(event_total_registrations) >= parseInt(event_maximum_registration_limit)) {
             seat_sold = true;
             allow_register = false;
             if (event_attendee_waiting_enabled == 1) {
                allow_register = true;
                seat_waiting = true;
             }
          } else {
             seat_available = true;
          }                  
       }

      if(showSeatAvailability == '1'){
        seat_left_message = '<span class="seat">'+(parseInt(event_maximum_registration_limit) - parseInt(event_total_registrations))+' Seats left</span>';
        setSeatLeft(parseInt(event_maximum_registration_limit) - parseInt(event_total_registrations));
        if ((parseInt(event_maximum_registration_limit) - parseInt(event_total_registrations)) <= 5) {
          var seat_message = '<div class="warning">Limited Seats</div>';
          setEventBuyStatus('limited');
          setEventBuyStatusTag('Limited seats');
        }

        if (parseInt(event_total_registrations) >= parseInt(event_maximum_registration_limit)) {
          seat_left_message = '<span class="seat">Sold Out</span>';
          seat_message = '<div class="warning closed">Sold Out</div>';
          setEventBuyStatus('sold');
          setEventBuyStatusTag('Sold out');
        }

        if (allow_register == false) {
          if (seat_sold == true) {
              seat_message = '<div class="warning closed">Sold Out</div>';
              setEventBuyStatus('sold');
              setEventBuyStatusTag('Sold out');
          } else if(coming_soon == true) {
            setEventBuyStatus('');
            setEventBuyStatusTag('');
              seat_message = '<div class="warning closed">Coming Soon</div>';
          } 
        }
      }

      if(registration_closed && !registration_disabled && !allow_register) {
          seat_message = '<div class="warning closed">Registration Closed</div>';
          setEventBuyStatus('');
          setEventBuyStatusTag('');
      }
      if(registration_disabled)
      {
          seat_message = '';
          seat_left_message = '';
          setEventBuyStatus('');
          setEventBuyStatusTag('');
      }
      let isPpsRequired          = typeof eventDetails.bce_pps_required != 'undefined' ? eventDetails.bce_pps_required : 0;
      let venueName             = (eventDetails.session.ea_venue_name ==='null')?'':eventDetails.session.ea_venue_name;          
      let venue = (venue_location===null)?'':venue_location;
      let venue_room      = (eventDetails.session.ea_session_venue_room ===null)?'':eventDetails.session.ea_session_venue_room;
      let venueAddress    = eventDetails.session.venue_address;
      /**timezone datetime coversion **/
      let session_timezone = eventDetails.session.ea_session_time_zone;
      let default_start_datetime = moment(eventDetails.session.ea_session_start_date + ' ' + eventDetails.session.ea_session_start_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);
      
      let default_end_datetime = moment(eventDetails.session.ea_session_end_date + ' ' + eventDetails.session.ea_session_end_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);

      if(schedule_type == 'multiple'){
        default_start_datetime = moment(eventDetails.bce_start_date + ' ' + eventDetails.bce_start_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);
      
        default_end_datetime = moment(eventDetails.bce_end_date + ' ' + eventDetails.bce_end_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);

      }
      let start_date_tz = default_start_datetime.format("DD-MM-YYYY");
      let start_time_tz = default_start_datetime.format("h:mm A");
      let end_date_tz = default_end_datetime.format("DD-MM-YYYY");
      let end_time_tz = default_end_datetime.format("h:mm A");
      // console.log('sel', selected_timezone);
      if (typeof selected_timezone !== 'undefined' && selected_timezone != '') {
        // selected_timezone = parseInt(selected_timezone)+0;
        // console.log(selected_timezone);
        // var tz_start_datetime = moment(default_start_datetime).utcOffset(selected_timezone);
        var tz_start_datetime = moment(default_start_datetime).tz(selected_timezone);
        // var tz_end_datetime = moment(default_end_datetime).utcOffset(selected_timezone);
        var tz_end_datetime = moment(default_end_datetime).tz(selected_timezone);
        start_date_tz = tz_start_datetime.format("DD-MM-YYYY");
        start_time_tz = tz_start_datetime.format("h:mm A");
        end_date_tz = tz_end_datetime.format("DD-MM-YYYY");
        end_time_tz = tz_end_datetime.format("h:mm A");                 
        
      }

      var date_diff                    = (Date.parse(end_date_tz) - Date.parse(start_date_tz))/86400000;
                
      var weekday                     = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
      var startDate                   = start_date_tz.split('-');
      var startMonth                  = GetMonthName(Number(startDate[1]).toString());
      let startMonthFull              = GetMonthName(Number(startDate[1]).toString(), true);
      var startDay                    = startDate[0];
      var newDate                     = new Date(startDate[1]+'/'+startDate[0]+'/'+startDate[2]);
      var startDayName                = weekday[newDate.getDay()];
      var startMonthNumber            = (newDate.getMonth())+1;
      let startYear                   = startDate[2];

      let startDateOnly               = `${startDayName}, ${startDay} ${startMonthFull} ${startYear}`; 
      setEventStartDate(startDateOnly);

      var endDate                      = end_date_tz.split('-');
      var endMonth                     = GetMonthName(Number(endDate[1]).toString());
      var endDay                       = endDate[0];

      var now   = moment(default_end_datetime);
      var then  = moment(default_start_datetime);
    
      var duration    = moment.duration(now.diff(then));
      var dayDiff     = duration.days();
      var hourDiff    = duration.hours();
      var minutesDiff = duration.minutes();
      var diff = '';
      if (dayDiff > 0) {                
          diff += dayDiff + ' D ';
      }
      if (hourDiff > 0) {                
        diff += hourDiff + ' Hr ';
      }
      if (minutesDiff > 0) {                
        diff += minutesDiff + ' Min';
      }

      setEventTimeDiff(diff);

      
      var multi = '';
      // console.log('schedule_type', schedule_type);
      if (schedule_type == 'basic' && selected_timezone != '') {
        if(tz_start_datetime.format("L") === tz_end_datetime.format("L")) {
            date_html = start_time_tz+' - '+end_time_tz+' ('+diff+')';
        } else {
            date_html   = startDay+' '+startMonth+' '+start_time_tz+' - '+endDay+' '+endMonth+' '+end_time_tz;
        }
      } else if (schedule_type == 'multiple' && selected_timezone != '') {
        if(tz_start_datetime.format("L") === tz_end_datetime.format("L")) {
          date_html = start_time_tz+' - '+end_time_tz+' ('+diff+')';
        } else {
            date_html   = startDay+' '+startMonth+' '+start_time_tz+' - '+endDay+' '+endMonth+' '+end_time_tz;
        }
        // date_html = schedule_description;          
        venue = '';
        venue_room = '';   
        venueName = ''; 
        venueAddress = '';
        multi += '<a href="javascript:void(0);"  data-toggle="modal" data-target="#sessionModal" onclick="multiSessionModal('+event_id+')">';
        multi += 'Show All Sessions</a>';
      }

      if(eventDateTime >= currentDateTime) 
      {
        let eventsHtml = '';
        if (registration_disabled == 0) {
          
          if (registration_closed == true) {
            addToCartButton = <Button variant="outline" className="w-100 mb-3" size="md">Registration closed</Button>;
            // eventsHtml        += '<p class="reg-closed">Registration Closed</p>';
          } else if (allow_register == 1) {
            if (seat_waiting == true) {
              addToCartButton = <Button variant="outline" className="w-100 mb-3" size="md" onClick={() => {localStorage.setItem('onlyWaitingList', true);waitingListURL.isReact ? navigate(waitingListURL.url) : window.location.assign(waitingListURL.url)}}>Add to waiting list</Button>;
            // eventsHtml += `<button class="btn" onclick="enrollItem(${event_id},'booking_event', '${bce_slug}', ${isPpsRequired}, '2')">Add to waiting list</button>`;
            } else if (seat_available == true) {
              if(price_type == 'free'){
                addToCartButton = <EnrollNowButton variant="outline" className={"w-100 mb-3"} itemType={itemType} itemId={coursedetails.course.id} />;
                // addToCartButton = <Button variant="outline" className="w-100 mb-3" size="md">{miscellaneous.event_free_button}</Button>;
                // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_enroll_button_display" onclick="enrollItem(${event_id},'booking_event', '${bce_slug}')">${_free_event_btn}</button>`;
              } else if(isCartEnabled){
                
                if(inCart(event_id,'booking_event')){
                  
                  addToCartButton = <AddToCartButton itemId={coursedetails.course.id} itemType={itemType}/>; //<Button variant="outline" className="w-100 mb-3" size="md">Go to Cart</Button>;
                  buyNowButton    = <BuyNowButton itemId={coursedetails.course.id} itemType={itemType}/>;//<Button variant="secondary"  className="w-100 mb-3"  size="md">Buy now</Button>;
                    eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="goToCart()">Go to Cart</button>`;  
                    // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${event_id},'booking_event')">${_event_buy_now_label} </button>`;  
                }
                else{

                  addToCartButton = <AddToCartButton itemId={coursedetails.course.id} itemType={itemType}/>; //<Button variant="outline" className="w-100 mb-3" size="md">Add to Cart</Button>;
                  buyNowButton    = <BuyNowButton itemId={coursedetails.course.id} itemType={itemType}/>;//<Button variant="secondary"  className="w-100 mb-3"  size="md">Buy now</Button>;
                    eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn w-100" onclick="addToCart(this, ${event_id},'booking_event')" style="margin-right: 10px;">Add to Cart</button>`;  
                    // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${event_id},'booking_event')">${_event_buy_now_label}</button>`;  
                  }
              }else
              {
                buyNowButton    = <BuyNowButton itemId={coursedetails.course.id} itemType={itemType}/>;//<Button variant="secondary"  className="w-100 mb-3"  size="md">Buy now</Button>;
                // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${event_id},'booking_event')">${_event_buy_now_label}</button>`;  
              }
            }       
          } else { 
            if (seat_sold == true) {
              addToCartButton    = <Button variant="outline" className="w-100 mb-3" size="md">Sold Out</Button>;
                eventsHtml        += '<p class="reg-closed">Sold Out</p>';
            } else if (coming_soon == true) {
              addToCartButton    = <Button variant="outline"  className="w-100 mb-3"  size="md">Coming Soon</Button>;
                eventsHtml        += '<p class="reg-closed">Coming Soon</p>';
            }
            }
        } else {
          addToCartButton    = <Button variant="outline" className="w-100 mb-3" size="md" onClick={viewMoreClickHandler}>  View More</Button>;
        eventsHtml        += bce_enquiry_needed != '1' ? '<p class="reg-closed reg-unavailable">Temporarily Unavailable</p>' : '';
        }
      }
      console.log('date_html', date_html);
      setAddToCartBtn(addToCartButton);
      setBuyNowBtn(buyNowButton);
      setEventDateHtml(date_html);
  }

  const eventDetailClickHandler = (event) => {
    if(event.target.tagName !== "BUTTON"){
      navigate("/"+bce_slug);
      // console.log('div clicked!')
    }
  }

  useEffect(() => {
    renderEventActivities();
  },[eventDetails, selectedTimeZone]);
  // console.log('status',eventBuyStatus);
  return (
    <div className="event-block-wrapper course-event-wrapper course-available-dates res-course-available-dates">
      <div className={`${eventBuyStatus || ""} carousel-block p-0`} onClick={eventDetailClickHandler}>
        <div className="event-header">
          {/* <h1>{moment(eventDetails?.bce_start_date).format('DD/MM/YYYY')}</h1> */}
          <h1>{eventStartDate}</h1>
          {/* <h1>Wednesday, 03 August 2022</h1> */}
          {/* <p>7:00 AM - 10:00 AM ({eventTimeDiff})</p> */}
          <p>{eventDateHtml}</p>
          <div className="d-flex align-items-center gap-3">
            {
              bceDeliveryType == 'live' ? (
                <IconDesc
                  icon={rssIcon}
                  paraDesc="Live Class"
                />
              ) : (
                (schedule_type === 'basic') &&
                <IconDesc
                  icon={geoMarkIcon}
                  paraDesc={bceVenue + ', '+venue_location}
                  className="mb-1 mb-md-0"
                />
              )
            }
            
            { seatLeft > 0 && <IconDesc
              icon={archiveIcon}
              paraDesc={seatLeft+" Seats left"}
            />
            }
          </div>
        </div>
        <div className="desc-carousel desc-prices">
              { displayPrice == 1 && (
                (price_type === 'paid') ? (
                <div className="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                    <div className="pricing-slot pricing-left">
                      <span>{currentPricingLabel}</span>
                      <div className="price">{currentCurrency.symbol}{event_price} 
                      {/* <span>{currentCurrency.symbol}229</span> */}
                      </div>
                    </div>
                    <span className="separtor-price-set"></span>
                    {
                      (_member_status == '1' && showMemberPrice == '1') &&
                      <div className="pricing-slot pricing-right">
                        <span>{memberPricingLabel}</span>
                        <div className="price">{currentCurrency.symbol}{_member_price}</div>
                      </div>
                      
                    }
                    
                </div>

                ) : (
                    <div className="d-flex align-items-end justify-content-between course-price-wrapper mt-0 free-label-wrapper">
                      <div className="pricing-slot pricing-left">
                        <div className="price">{miscellaneous.event_free_label}</div>
                      </div>
                    </div>
                  )
                )
              }
        </div>
        <div className="desc-carousel buttons-group">
          <div className="rating-cart-wrapper">
          {
            coursedetails?.course?.bce_is_approval_required == "1" ? (
              <IamInterestedButton
                item={{
                  item_name: coursedetails?.course?.bce_name,
                  item_id: coursedetails?.course?.id,
                }}
                variant="outline"
                itemId={coursedetails?.course?.id}
              />
            ) : (
              <>
                {addToCartBtn}
                {buyNowBtn}
              </>
            )
          }          
                {/* <Button
                  variant="secondary"
                  className="w-100 mb-3"
                  size="md"
                >
                  Buy now
                </Button> */}
              </div>
            {
              bce_enquiry_needed == 1 &&
              <Button
                variant="outline"
                className="w-100 border-0 mb-0"
                size="md"
                onClick={()=>enquireFn(coursedetails, itemType)}
                >
                {chatIcon} {miscellaneous.enquiry_button}
              </Button>
            }
        </div>
      </div>
      <EventTag eventCountInfo={eventBuyStatusTag} />
    </div>
  );
}

export default CourseEvent;
